import styled from "styled-components"
import media from "src/styles/media"

export const NavItem = styled.li`
  font-weight: 300;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  margin: 0 25px;
  font-size: 17px;

  @media screen and (min-width: 768px) and (max-width: 1020px) {
    font-size: 14px;
    margin: 0 10px;
    align-items: flex-start;
  }

  @media screen and (min-width: 1020px) and (max-width: 1200px) {
    margin: 0 15px;
  }

  ${media.lessThan("md")`
        text-align: left;
        margin: 0 0 25px 0;
        align-items: flex-start;
    `}

  a {
    display: block;
    color: inherit;
    text-decoration: inherit;
    transition: all 0.4s;

    &:hover,
    &.active,
    .active & {
      color: #fff;
      text-decoration: none;

      &:after {
        width: 80%;
        opacity: 0.8;
      }
    }

    &:hover {
      text-shadow: 1px 1px 1px #fff;
    }

    &.active {
      font-weight: 600;
    }

    &:after {
      content: "";
      position: absolute;
      bottom: -4px;
      left: 0;
      opacity: 0;
      width: 0;
      height: 1.6px;
      background-color: var(--secondary);
      transition: all 0.4s;
    }

    ${props =>
      props.isButton &&
      `
        font-weight: 400;
        border-radius: 30px;
        padding: 6px 27px;
        background-color: var(--primary);
        box-shadow: 0 0 0 var(--primary);
        animation: pulse 2s infinite;

        svg{
          height: 20px;
          margin-bottom: 3px;
          margin-left: 5px;
        }

        &:after{
            display: none;
        }
    `}

    ${media.greaterThan("xl")`
        margin-left:  ${props => props.isButton && `40px !important`};
    `}
  }
`
